import { render, staticRenderFns } from "./app.component.vue?vue&type=template&id=73083d49"
import script from "./app.component.ts?vue&type=script&lang=ts&external"
export * from "./app.component.ts?vue&type=script&lang=ts&external"
import style0 from "./styles/index.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports